// src/pages/PendingFeeReportContainer.tsx
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getPendingFeeReport } from '../../apis/payments/pendingFeeReport';
import { getSchoolClassesConfig } from '../../apis/schoolConfig';
import { RootState } from '../../redux/store';
import { SchoolClassesConfig } from '../../types/schoolConfigType';
import PendingFeeReport from './PendingFeeReport';
import { PendingFeeRecord } from './PendingFeeReportTable';
import { PendingPaymentsReport, PendingPaymentsReportResponse } from './types';
import { buildPendingFeeReportData } from './utils';

const PendingFeeReportContainer: React.FC = () => {
  const [data, setData] = useState<PendingFeeRecord[] | null>(null);
  const [allClasses, setAllClasses] = useState<SchoolClassesConfig>();
  const [loading, setLoading] = useState(false);
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  const onSearch = async (
    academicYear: string,
    grade: string,
    division: string,
    asOnDate: string
  ) => {
    setLoading(true);
    try {
      const perPage = 100;
      let pageNo = 1;
      const aggregatedData: PendingPaymentsReport[] = [];

      // fetch all pages
      while (true) {
        // eslint-disable-next-line no-await-in-loop
        const response = (await getPendingFeeReport(
          academicYear,
          grade,
          division,
          asOnDate,
          pageNo,
          perPage
        )) as unknown as PendingPaymentsReportResponse;

        const rows = response.data || [];
        aggregatedData.push(...rows);

        if (!response.hasMore) break;
        pageNo += 1;
      }

      setData(buildPendingFeeReportData(aggregatedData));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch pending fee report', err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSchoolClassesConfig(loggedInUser.school).then((response) => {
      setAllClasses(response.data as unknown as SchoolClassesConfig);
    });
  }, [loggedInUser]);

  return (
    <>
      <PendingFeeReport
        data={data}
        onSearch={onSearch}
        allClasses={allClasses as SchoolClassesConfig}
        loading={loading}
      />
    </>
  );
};

export default PendingFeeReportContainer;
